<div class="app__discovery--widget--container">
  <div class="app__itemCard-radioGroup app__sub-title items-start text-[#53565B] font-semibold mt-5 m-0 px-2">
    <span [innerHTML]="innerContent?.title"></span>
  </div>
  <div class="app__discovery--inner--section mt-9">
    <div
      class="app__itemCard w-[330px] h-[250px] sm:h-[250px] sm:w-[330px] rounded-2xl p-6"
      style="box-shadow: 0px 10px 32px -4px #18274b1a; border: 1px solid #dcdcdc"
    >
      <img src="../../../../../assets/images/download_gather.svg" />

      <div class="app__itemCard-header w-full mt-3 mb-1">
        <h2 class="app__form--attribute--title text-base font-semibold" [innerHTML]="innerContent?.cardSubtitle"></h2>
      </div>
      <button class="app__btn--primary mb-0 mt-0" (click)="getDownloadURLForOnboardingCheckList()">
        <span class="mr-2"> <img src="../../../../../../assets/images/white-filled-download.svg" /></span>
        Download
      </button>
    </div>
  </div>
</div>

<mat-divider class="mat-divider m-0 sm:mb-6 sm:mt-[42px]" aria-orientation="horizontal"></mat-divider>
<div class="app__between--justified--content w-full h-[65px] pl-0 pr-0 max-[480px]:pt-4">
  <button class="app__centered-item bg-transparent font-bold text-xs gap-2 cursor-pointer" (click)="handleSteps('backward')">
    <span class="app__centered-item gap-2 text-[#18191C]"
      ><span class="material-icons text-base"> arrow_back</span> <span class="text-sm font-semibold"> Back</span></span
    >
  </button>
  <div class="w-[158px]">
    <button
      class="app__btn--primary mt-0 max-[480px]:items-center max-[480px]:h-[38px] max-[480px]:m-0"
      type="submit"
      (click)="handleSteps('forward')"
    >
      Continue
    </button>
  </div>
</div>
